import {EnableSidebar, PageTitle} from '../../../_metronic/layout/core'
import {TowelsPage} from '../../modules/towels/TowelsPage'

const DashboardWrapper = () => {
  return (
    <EnableSidebar>
      <PageTitle description='Sistema de Toallas' breadcrumbs={[]}>
        Dashboard
      </PageTitle>

      <div className='mt-10'>
        <div className='card'>
          <div className='card-header'>
            <h3 className='card-title'>Listado de Toallas</h3>
          </div>

          <div className='card-body'>
            <TowelsPage />
          </div>
        </div>
      </div>
    </EnableSidebar>
  )
}

export {DashboardWrapper}
